import React from 'react';
import { HeatmapV2 } from '../../../../../../../../../../Components/HeatmapV2';
import AsyncSection from '../../../../../../../../../../Components/AsyncSection';
import './index.scss';
import {
    HEADER_TEXT,
    HEATMAP_KEY,
    TREND_STYLE,
} from './constants';

// The comparison-mode heatmap. Same grid as BenchmarkHeatmap — the tree
// drill-down, the sticky category column and the Excel/JPG exports all come
// from HeatmapV2 — but opted into the trend cell renderer, so each cell reports
// the change between the two rounds instead of a single score.
const TrendHeatmap = (props) => {
    const api = props.fetchTrendRaterHeatmapApi;
    const columns = api.data && api.data.columns ? api.data.columns : [];
    const rows = api.data && api.data.data ? api.data.data : [];
    return (
        <AsyncSection api={api} isEmpty={() => {
            return false
        }} loaderHeight={300} loaderWidth={600}>
        <div className='cardwrapper'>
            <h3>{HEADER_TEXT.title}</h3>
            <p className='description-container'>{HEADER_TEXT.description}</p>

            <HeatmapV2
                isMultipleSheetsNeeded={true}
                isHeaderSectionHidden={true}
                id='trend-heatmap-grid'
                heatmapType={'Trend Heatmap'}
                columns={columns}
                childColumns={columns}
                headers={[]}
                selectedHeaders={[]}
                data={rows}
                trendStyle={TREND_STYLE}
                onSelectHeader={() => { }}
                showHeadersLoader={false}
                showTableLoader={false}
                showErrorState={false}
                onExpand={() => { }}
                selectedScoreLevel={['favourable']}
                scoreLevelList={[]}
                onChangeScoreType={() => { }}
                comparisonLevelList={[]}
                selectedLevel={[]}
                onChangeComparisonLevel={() => { }}
            />

            <div className='trend-heatmap-key'>
                <span className='trend-heatmap-key__item'>
                    {/* The diverging scale itself, red through to green. */}
                    <span className='trend-heatmap-key__swatch' />
                    {HEATMAP_KEY.shading}
                </span>
            </div>

            <p className='trend-heatmap-key__note'>{HEADER_TEXT.note}</p>
        </div>
        </AsyncSection>
    );
};

export default TrendHeatmap;
